import { strollResource } from '@/resources/stroll_resource'
import { LatLng } from 'leaflet'

async function fetchStrolls({commit}, payload) {
  const getParams = {}
  if (payload && payload.categories) {
    getParams.categories = payload.categories
  }
  const response = await strollResource.get(getParams)
  const strolls = response.body.items
  const categories = []
  const alreadyAddedCategoryIds = []
  strolls.forEach(stroll => {
    // GeoDjango stores the coordinates in reverse
    stroll.point.coordinates.reverse()
    // Extract categories from strolls so they are relevant
    stroll.categories.forEach(category => {
      if (alreadyAddedCategoryIds.includes(category.id)) {
        return false
      }
      categories.push(category)
      alreadyAddedCategoryIds.push(category.id)
    })
  })
  categories.sort((c1, c2) => c1.name.toUpperCase() < c2.name.toUpperCase() ? -1 : 1)
  commit('setStrolls', { strolls })
  commit('setCategories', { categories })
}

// eslint-disable-next-line
async function fetchStroll({commit}, payload) {
  const response = await strollResource.get({id: payload.id})
  const stroll = response.body
  stroll.point.coordinates.reverse()
  stroll.checkpoints.forEach(checkpoint => {
    checkpoint.point.coordinates.reverse()
  })
  return stroll
}

// eslint-disable-next-line
async function searchStrolls({commit}, payload) {
  const searchTerm = payload.searchTerm
  const response = await strollResource.query({search: searchTerm})
  return response.body.items
}

// eslint-disable-next-line
function calculateUserDistanceFromStroll({commit}, payload) {
  const stroll = payload.stroll
  const locationCoordinates = payload.userLocation
  const userLocation = new LatLng(locationCoordinates.latitude, locationCoordinates.longitude)
  const strollLocation = new LatLng(stroll.point.coordinates[0], stroll.point.coordinates[1])
  const distance = userLocation.distanceTo(strollLocation)
  return distance
}

export const actions = {
  calculateUserDistanceFromStroll,
  fetchStrolls,
  fetchStroll,
  searchStrolls,
}
